import React from 'react'

import noop from 'lodash/noop'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    onClose?: () => void
    maxHeight?: boolean
  }
>

export const ContextMenuContext = React.createContext({onClose: noop})

const ContextMenu = ({className, children, onClose = noop, maxHeight = false, ...props}: Props) => {
  const contextValue = React.useMemo(() => ({onClose: onClose || noop}), [onClose])
  return (
    <div {...props} className={cn('ContextMenu', {maxHeight}, className)}>
      <ContextMenuContext.Provider value={contextValue}>{children}</ContextMenuContext.Provider>
    </div>
  )
}

export default ContextMenu
